import React from "react";
const IconCritical = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DD304F",
    d: "M23.913 19.61l.001-.001-.04-.07c-.02-.037-.039-.074-.062-.108L12.906.54C12.729.221 12.392 0 11.999 0c-.425 0-.79.257-.95.623h-.001L.227 19.364l.01.007c-.152.183-.236.414-.237.653 0 .573.465 1.038 1.038 1.038h21.924c.573 0 1.038-.465 1.038-1.038 0-.148-.032-.288-.087-.415zm-11.903-.508c-.831 0-1.505-.654-1.505-1.485 0-.831.673-1.504 1.505-1.504.811 0 1.485.672 1.485 1.504 0 .394-.156.772-.435 1.05-.278.279-.656.435-1.05.435zm1.485-13.127v8.188h-.001v.005c0 .339-.274.605-.605.605h-1.767c-.34 0-.615-.266-.615-.605V5.997l-.002-.023c0-.323.25-.577.56-.601v-.005h1.82c.332.003.6.26.608.59h.001v.017z"
  }));
};
export default IconCritical;